// New accounts that sign up with Google start with their Google first name as the optional Name
// (Settings → General; shown in the sidebar). Never overwrites a name that's already set.
import { getAdditionalUserInfo } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

export default async function prefillGoogleName(result) {
  const info = getAdditionalUserInfo(result);
  const firstName = (info?.profile?.given_name || '').trim().slice(0, 50);
  if (!info?.isNewUser || info.providerId !== 'google.com' || !firstName) return;
  const profileRef = doc(db, 'users', result.user.uid, 'userSettings', 'profile');
  const snap = await getDoc(profileRef);
  if (snap.data()?.displayName) return;
  await setDoc(profileRef, { displayName: firstName }, { merge: true });
}
